const headCells = [
    {
        id: 'Task ID',
        numeric: false,
        disablePadding: false,
        label: 'Task ID',
    },
    {
        id: 'Opportunity ID',
        numeric: false,
        disablePadding: false,
        label: 'Opportunity ID',
    },
    {
        id: 'Contact Name',
        numeric: false,
        disablePadding: false,
        label: 'Contact Name',
    },
    {
        id: 'Created By',
        numeric: false,
        disablePadding: false,
        label: 'Created By',
    },
    {
        id: 'Assigned to',
        numeric: false,
        disablePadding: false,
        label: 'Assigned to',
    },
    {
        id: 'Type',
        numeric: false,
        disablePadding: false,
        label: 'Type',
    },
    {
        id: 'Start Date',
        numeric: false,
        disablePadding: false,
        label: 'Start Date',
    },
    {
        id: 'End Date',
        numeric: false,
        disablePadding: false,
        label: 'End Date',
    },
    {
        id: 'Stage',
        numeric: false,
        disablePadding: false,
        label: 'Stage',
    },
    {
        id:'Status',
        numeric: false,
        disablePadding: false,
        label:'Status',
    },
];

export { headCells }